import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PercentageCreateDto } from '../dtos/percentage/percentageCreateDto';
import { PercentageUpdateDto } from '../dtos/percentage/percentageUpdateDto';

@Injectable({
  providedIn: 'root'
})
export class PercentageService {
  constructor(private http: HttpClient) { }
  public apiUrl = `${environment.apiUrl}/Percentages`;

  getList() : Observable<any>{
    return this.http.get(`${this.apiUrl}`)
  }

  getLookup() : Observable<any>{
    return this.http.get(`${this.apiUrl}/GetLookup`)
  }

  getLookupModel(brandId : number) : Observable<any>{
    return this.http.get(`${this.apiUrl}/GetLookupModel?brandId=${brandId}`)
  }

  create(percentageCreateDto:PercentageCreateDto): Observable<any>{
    return this.http.post(`${this.apiUrl}`, percentageCreateDto)
  }

  update(id:number, percentageUpdateDto:PercentageUpdateDto): Observable<any>{
    return this.http.put(`${this.apiUrl}/${id}`, percentageUpdateDto)
  }
  delete(id:number){
    return this.http.delete(`${this.apiUrl}/${id}`)
  }
}